/**
 * DOM Ready alternative.
 * Works in/with async scripts!
 */

export const interactive = () => {
  return new Promise((resolve) => {
    if (document.readyState !== 'loading') {
      resolve();
    }
    else {
      document.addEventListener('readystatechange', () => {
        if (document.readyState === 'interactive') {
          resolve();
        }
      });
    }
  });
};
